<script setup lang="ts">
import Modal from '~/components/common/modal.vue'
const props = defineProps({
  modalId: {
    type: String,
    required: false,
    default: null
  },
  modalWidthClass: {
    type: String,
    required: false,
    default: ''
  },
  modalPositionClass: {
    type: String,
    default: ''
  },
  isShowIconClose: {
    type: Boolean,
    default: true
  },
  isClickBackdropClose: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['handleCloseModal'])
</script>
<template>
  <Modal
    :modalId="props.modalId"
    :isShowIconClose="isShowIconClose"
    :isClickBackdropClose="isClickBackdropClose"
    modalBodyClasses="modal-auth__body"
    modalWrapperClasses="modal-auth__wrapper"
    :modalDialogClasses="`modal-auth__dialog ${modalWidthClass} ${modalPositionClass}`"
    modalHeaderClasses="modal-auth__header"
    @handleCloseModal="emit('handleCloseModal')"
  >
    <div class="modal-auth">
      <div class="h-100 d-flex flex-column">
        <slot></slot>
      </div>
    </div>
  </Modal>
</template>
<style lang="scss" scoped></style>
